export default "__VITE_ASSET__ced218e6__"